import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const LoginBypassManagerPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.LoginBypassManager}
        fetchRecordsUrl={AdminReqUrls.admin__loginBypassMngr__mainPage_fetch_recordList}
        pageDescription={`Manage and customize login-bypass links, including enabling/disabling, or deleting them, modify redirect links, and update/edit records, such as guest user records. This functionality ensures that administrators can efficiently control access options and maintain up-to-date user data.`}
    />)
});
export default LoginBypassManagerPage;
